// The game's entry: p5 and p5.sound first, then the p5 sketch functions, which
// go on window because p5's global mode looks for them there.
import './sketch/p5'
import 'p5/lib/addons/p5.sound.min.js'

import type p5 from 'p5'
import { Game } from './sketch/game/game'
import { keyPressed, mouseClicked } from './sketch/input'
import { Menu } from './sketch/menu/menu'
import { Music, type MusicFiles } from './sketch/music'
import { ScoreBoard } from './sketch/scoreboard'
import { Snakes } from './sketch/snakes'
import {
    game,
    gameSounds,
    menu,
    music,
    setGame,
    setGameSounds,
    setMenu,
    setMusic,
    setScoreboard,
    setSnakes
} from './sketch/state'
import { Mouse } from './sketch/utils/mouse'
import { windowResized } from './sketch/utils/utils'

let backgroundColor: p5.Color
let musicFiles: MusicFiles
let mouse: Mouse

function preload() {
    // During preload p5 swaps in a loadSound that the page waits for
    const { loadSound } = window as unknown as Pick<p5, 'loadSound'>

    musicFiles = {
        menu: loadSound('./assets/music/menu.mp3'),
        game: loadSound('./assets/music/game.mp3')
    }
    setGameSounds({
        died: loadSound('./assets/sounds/end.wav'),
        freeze: loadSound('./assets/sounds/freeze.wav'),
        unfreeze: loadSound('./assets/sounds/unfreeze.wav'),
        teleport: loadSound('./assets/sounds/teleport.wav'),
        disappear: loadSound('./assets/sounds/disappear.wav'),
        burn: loadSound('./assets/sounds/burn.wav'),
        rebirth: loadSound('./assets/sounds/rebirth.wav'),
        shrink: loadSound('./assets/sounds/shrink.wav'),
        ghost: loadSound('./assets/sounds/ghost.wav'),
        warning: loadSound('./assets/sounds/warning.wav')
    })
}

function setup() {
    // Canvas settings
    createCanvas(windowWidth, windowHeight)
    frameRate(60)
    noCursor()
    backgroundColor = color(20)

    gameSounds.died.setVolume(0.4)
    gameSounds.freeze.setVolume(1)
    gameSounds.unfreeze.setVolume(0.3)
    gameSounds.teleport.setVolume(1)
    gameSounds.disappear.setVolume(0.5)
    gameSounds.burn.setVolume(0.5)
    gameSounds.rebirth.setVolume(0.5)
    gameSounds.shrink.setVolume(0.7)
    gameSounds.warning.setVolume(0.8)

    // Create Game Instances (the game before the menu: the menu's snakes are born into it)
    setScoreboard(new ScoreBoard())
    setSnakes(new Snakes())
    setMusic(new Music(musicFiles))
    setGame(new Game([]))
    setMenu(new Menu())
    mouse = new Mouse()

    // Start music on user action
    userStartAudio().then(() => music.userStartAudio())
}

function draw() {
    background(backgroundColor)
    game.update()
    game.draw()
    menu.draw()
    mouse.draw()
}

Object.assign(window, { preload, setup, draw, keyPressed, mouseClicked, windowResized })
